<template>
  <div class="flex flex-col h-full">
    <invitation-notifications v-if="currentUser.id" />
    <OnboardingV3BackArrow />
    <SearchSection />
    <div
      v-if="!isMobile"
      class="publish"
    >
      <aha-button
        variant="base"
        size="md"
        @click="handleOpenModalPublishPresentations"
      >
        <span>{{ $i18nPresenter.t('Publish my own') }}</span>
      </aha-button>
    </div>
    <div class="result--section">
      <!-- Categories Result -->
      <CategoryResultSection
        v-if="categorySelected.id && categorySelected.PresentationsCategories && isQueryByCategory"
        :categorySelected="categorySelected"
      />
      <div v-else>
        <!-- Search result -->
        <SearchResultSection
          v-if="(filteredPresentations
            && filteredPresentations.length > 0)
            || (noResult && isSearching)"
          :filteredPresentations="filteredPresentations"
          :noResult="noResult"
          :isSearching="isSearching"
          :searchText="searchText"
          :isLoadmore="isLoadmore"
          :isLoadingMore="isLoadingMore"
          @loadMore="loadMore"
        />
        <!-- Normal browse, no categories and search -->
        <div v-else>
          <!-- Desktop version -->
          <div v-if="onlyShowDesktopVersion">
            <div
              class="templates"
              v-if="templateCategories
                && templateCategories.length > 0
                && filteredPresentations.length === 0
                && !noResult
              "
            >
              <div
                class="template-container_item mb-4 slider __slider"
              >
                <h2 class="title-template-type">
                  <span class="icon-template-type">
                    <img :src="require('@/assets/images/icon/star.svg')">
                  </span>{{ $i18nPresenter.t("Staff Choice") }}
                </h2>
                <div
                  :class="
                    [`slider __prev --ahaslides-pick`,{hidden: isLoadingTemplateAdminPicked}]"
                  @click="trackSliderBtn('Back')"
                >
                  <aha-icon
                    width="12"
                    height="18"
                    viewBox="0 0 8 14"
                    name="arrow-no-tail"
                    class="transform rotate-180"
                  />
                </div>
                <div
                  :class="
                    [
                      `slider __next --ahaslides-pick`,
                      {
                        hidden: isLoadingTemplateAdminPicked
                      }
                    ]"
                  @click="trackSliderBtn('Next')"
                >
                  <aha-icon
                    width="12"
                    height="18"
                    viewBox="0 0 8 14"
                    name="arrow-no-tail"
                  />
                </div>
                <TemplateSliderSkeleton v-if="isLoadingTemplateAdminPicked" />
                <swiper
                  v-if="!isLoadingTemplateAdminPicked
                    && templateAdminPicked.length > 0"
                  :ref="`swiper-main`"
                  :autoUpdate="true"
                  :options="getSliderOptions({
                    folderId: 'ahaslides-pick',
                    folderName: 'AhaSlides Pick',
                  })"
                >
                  <swiper-slide
                    class="swiper-slide__template-library"
                    v-for="presentation in templateAdminPicked"
                    :key="`template-admin-pick-${presentation.id}`"
                  >
                    <TemplateCard
                      :presentation="presentation"
                      class="template-library"
                      where="AhaSlides Pick"
                      templateLocation="template library"
                    />
                  </swiper-slide>
                </swiper>
              </div>
              <div class="template-container_item slider __slider">
                <h2 class="title-template-type">
                  <span class="icon-template-type">
                    <img :src="require('@/assets/images/icon/fire-alt.svg')">
                  </span>{{ $i18nPresenter.t('Newly Added') }}
                </h2>
                <div
                  :class="{
                    'slider __prev --newly-added': true,
                    hidden: isLoadingNewlyAdded,
                  }"
                  @click="trackSliderBtn('Back')"
                >
                  <aha-icon name="arrow-no-tail" class="transform rotate-180" />
                </div>
                <div
                  :class="{
                    'slider __next --newly-added': true,
                    hidden: isLoadingNewlyAdded,
                  }"
                  @click="trackSliderBtn('Next')"
                >
                  <aha-icon name="arrow-no-tail" />
                </div>
                <TemplateSliderSkeleton v-if="isLoadingNewlyAdded || getNewlyAddedError" />
                <swiper
                  ref="swiper-newly-added"
                  v-else
                  :autoUpdate="false"
                  :options="getSliderOptions({
                    folderId: 'newly-added', folderName: 'Newly added',
                  })"
                  v-show="newlyAddedCommunityTemplates
                    && newlyAddedCommunityTemplates.length > 0"
                >
                  <swiper-slide
                    class="swiper-slide__template-library"
                    v-for="presentation in newlyAddedCommunityTemplates"
                    :key="presentation.id"
                  >
                    <TemplateCard
                      :presentation="presentation"
                      class="template-library"
                      where="Newly added"
                      templateLocation="template library"
                    />
                  </swiper-slide>
                </swiper>
              </div>
              <div class="mt-10" v-if="isLoadingTemplates && !templateCategories">
                <TemplateSliderSkeleton class="mb-24" />
                <TemplateSliderSkeleton class="mb-24" />
                <TemplateSliderSkeleton class="mb-24" />
                <TemplateSliderSkeleton />
              </div>
              <div>
                <div
                  v-for="category in templateCategories"
                  :key="category.folderId"
                  class="template-container_item mb-4 slider __slider"
                >
                  <div class="title-template-category-container">
                    <h2 class="title-template-type title-item-template-category mb-4 text-lg">
                      {{ $i18nPresenter.t(category.folderName) }}
                    </h2>
                    <a
                      :href="mappingLinkSeeAll[category.folderId] ? mappingLinkSeeAll[category.folderId] : 'https://presenter.ahaslides.com/apps/template-library'"
                      target="_blank"
                      class="title-template-see-all"
                      @click="trackingSeeAll(category.folderName)"
                    >
                      {{ $i18nPresenter.t('See all') }}
                    </a>
                  </div>
                  <TemplateSliderSkeleton v-if="isLoadingTemplates" />
                  <div class="container-template-category">
                    <TemplateCardCategory
                      v-for="presentation in category.presentations"
                      :key="category.folderId +'_' +presentation.id"
                      :presentation="presentation"
                      :where="category.folderName"
                      class="template-category-item template-library"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <!-- Mobile verion -->
            <TemplateHighlightSectionMobile
              :mode="'Pick'"
              :isLoading="isLoadingTemplateAdminPicked"
              :showMore="showLoadMoreAdminPicked"
              :templates="templateAdminPickedForMobileMini"
              @showMoreClicked="() => { showLoadMoreAdminPicked = true }"
            />
            <TemplateHighlightSectionMobile
              :mode="'Newly'"
              :isLoading="isLoadingNewlyAdded"
              :showMore="showLoadMoreNewlyAdded"
              :templates="newlyAddedCommunityTemplatesForMobileMini"
              @showMoreClicked="() => { showLoadMoreNewlyAdded = true }"
            />
            <div class="template-container_item template-container_item_category">
              <div
                v-for="category in templateCategories"
                :key="category.folderId"
                class="mb-4 slider __slider template-category-item"
              >
                <div class="title-template-category-container">
                  <h2 class="mb-4 text-lg title-template-type">
                    {{ $i18nPresenter.t(category.folderName) }}
                  </h2>
                  <a
                    :href="mappingLinkSeeAll[category.folderId] ? mappingLinkSeeAll[category.folderId] : 'https://presenter.ahaslides.com/apps/template-library'"
                    class="title-template-see-all"
                    target="_blank"
                    @click="trackingSeeAll(category.folderName)"
                  >
                    {{ $i18nPresenter.t("See all") }}
                  </a>
                </div>
                <TemplateSliderSkeleton v-if="isLoadingTemplates" />
                <swiper
                  v-if="!isLoadingTemplates
                    && category.presentations && category.presentations.length > 0"
                  :ref="`swiper-main`"
                  :autoUpdate="false"
                  :options="getSliderOptions(category)"
                >
                  <swiper-slide
                    v-for="presentation in category.presentations"
                    :key="`${presentation.id} - ${category.id}`"
                  >
                    <TemplateCardCategory
                      :presentation="presentation"
                      :where="category.folderName"
                      templateLocation="template library"
                      class="template-library"
                    />
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal section -->
    <ModalPublishPresentations
      @hide="closeModalPublishPresentations()"
      v-if="showModalPublishPresentations"
    />
    <TemplatePreviewPopup
      v-if="previewPopup"
      @hide="hidePreviewPopUp()"
      :presentationShareCode="previewShareCode"
    />
  </div>
</template>
<script>
// This component is DEPRECATED.
//
// **Related Issue:**
// Organizing Template Library by Primary Use Cases
// (https://ahaslides.atlassian.net/browse/AHA-28934) (Feature: F)
//
// **Feature Flag:**
// release-reorganising-template-library
//
// **Removal Conditions:**
// - The feature (F) is 100% live.
// - The feature flag is fully enabled.
// - The EU environment is no longer frozen
//   (details: https://ahaslides.atlassian.net/browse/AHA-30247).
//
// **Replacement:**
// Use "@/components-v2/template-library/v2/TemplateLibrary.js" instead.
//
// TODO: Remove this file once all the above conditions are met.

import _ from 'lodash'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { mapState, mapGetters, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'

import InvitationNotifications from '@/components-v2/common/global-notification/InvitationNotifications.vue'
import SearchSection from './template-container/SearchSection.vue'
import CategoryResultSection from './template-container/CategoryResultSection.vue'
import SearchResultSection from './template-container/SearchResultSection.vue'

import OnboardingV3BackArrow from '@/components-v2/common/onboarding/OnboardingV3BackArrow.vue'
import TemplateCard from '@/components-v2/template-library/template-container/TemplateCard.vue'
import TemplateCardCategory from '@/components-v2/common/template-library/TemplateCardCategory.vue'
import TemplateSliderSkeleton from './TemplateSliderSkeleton.vue'
import TemplateHighlightSectionMobile from './template-container/TemplateHighlightSectionMobile.vue'
import TemplatePreviewPopup from '@/components-v2/template/TemplatePreviewPopup.vue'
import ModalPublishPresentations from '../modals/PublishPresentations.vue'

import EventBus from '@/eventBus'
import Config from '@/config'
import utils from '@/util'
import constants from '@/constant'
import CategoryApi from '@/api/category'
import SearchApi from '@/api/search'
import 'swiper/css/swiper.css'

export default {
  components: {
    OnboardingV3BackArrow,
    ModalPublishPresentations,
    SearchSection,
    CategoryResultSection,
    SearchResultSection,
    InvitationNotifications,
    TemplateCard,
    TemplateCardCategory,
    TemplateSliderSkeleton,
    TemplateHighlightSectionMobile,
    TemplatePreviewPopup,
    Swiper,
    SwiperSlide,
  },
  data() {
    const mappingLinkAllRegion = {
      gb: {
        13502: 'https://presenter.ahaslides.com/apps/template-library/category/15',
        13400: 'https://presenter.ahaslides.com/apps/template-library/category/16',
        13412: 'https://presenter.ahaslides.com/apps/template-library/category/21',
        999999999: 'https://presenter.ahaslides.com/apps/template-library/category/19',
        99529: 'https://presenter.ahaslides.com/apps/template-library/category/16',
      },
      eu: {
        385: 'https://presenter.ahaslides.eu/apps/template-library/category/15',
        384: 'https://presenter.ahaslides.eu/apps/template-library/category/16',
        386: 'https://presenter.ahaslides.eu/apps/template-library/category/21',
        999999999: 'https://presenter.ahaslides.eu/apps/template-library/category/1',
      },
    }

    return {
      showModalPublishPresentations: false,
      noResult: false,
      searchText: '',
      isLoadingMore: false,
      isLoadmore: false,
      limit: 20,
      page: 1,
      filteredPresentations: [],
      mappingLinkSeeAll: mappingLinkAllRegion[Config.region],
      linkDefaultCategory: Config.region === constants.globalRegion ?
        'https://presenter.ahaslides.com/apps/template-library' :
        'https://presenter.ahaslides.eu/apps/template-library',
      showLoadMoreAdminPicked: false,
      showLoadMoreNewlyAdded: false,
      categorySelected: {},
      previewPopup: false,
      previewShareCode: '',
      onlyShowDesktopVersion: true,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters('presentationTemplates', [
      'templateAdminPicked',
      'isLoadingTemplateAdminPicked',
      'templateCategories',
      'isLoadingNewlyAdded',
      'getNewlyAddedError',
      'newlyAddedCommunityTemplates',
      'isLoadingTemplates',
      'templateCategories',
      'templateAdminPickedForMobileMini',
      'newlyAddedCommunityTemplatesForMobileMini',
      'templatesError',
    ]),
    isSearching() {
      if (this.$route.query.q) return true
      return false
    },
    isMobile() {
      return window.innerWidth < 1024
    },
    isQueryByCategory() {
      if (this.$route.query.category) return true
      return false
    },
  },
  watch: {
    $route: function handleChangeRoute(newRoute) {
      if (newRoute.name === 'TemplateLibrary'
        && newRoute.query.q) {
        // Reset value and queries input
        this.searchText = newRoute.query.q
        this.handleInputChanged()
      } else if (newRoute.name === 'TemplateLibrary'
        && newRoute.query.category) {
        // Query all presentation fit this categories
        this.getCategoryDetail(newRoute.query.category)
      } else {
        // Set blank to reload categories, trending default template
        this.filteredPresentations = []
        this.noResult = false
        this.categorySelected = {}
        this.$nextTick(this.initLazyLoad)
      }
    },
    filteredPresentations: function handleChangeFilteredPresentations(filteredPresentations) {
      if (filteredPresentations.length) {
        this.$nextTick(this.initLazyLoad)
      }
    },
  },
  async mounted() {
    this.triggerPreviewPopUp()
    this.triggerQueryByCategory()
    this.triggerQuerySearch()
    await this.getTemplatesAction()
    await this.getNewlyAddedAction()
    await this.getTemplatesAdminPickedAction()
    EventBus.$on('update-library-after-published', (template) => {
      if (template.customThumbnailImage === '_blank') {
        delete template.customThumbnailImage
      }
      this.updatePublishedTemplateInList(template)
    })
  },
  destroy() {
    EventBus.$off('update-library-after-published')
  },
  methods: {
    ...mapActions('presentationTemplates', [
      'getTemplatesAction',
      'getNewlyAddedAction',
      'getTemplatesAdminPickedAction',
      'updateNewlyAddedAfterPublishAction']),
    handleOpenModalPublishPresentations() {
      this.showModalPublishPresentations = true
      utils.mixpanelTracking('Template Library', 'Publish to Template Library')
    },
    closeModalPublishPresentations() {
      this.showModalPublishPresentations = false
    },
    trackSliderBtn(type) {
      this.clickingToScroll = type
    },
    getSliderOptions(category) {
      // return unique options for each slide
      // avoid using prev/next button on 1 slider also triggers the other sliders
      const { folderId: id, folderName } = category
      return {
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        noSwiping: false,
        cssMode: false,
        mousewheel: {
          forceToAxis: true,
        },
        spaceBetween: this.isMobile ? 20 : 24,
        navigation: {
          prevEl: `.slider.__prev.--${id}`,
          nextEl: `.slider.__next.--${id}`,
        },
        breakpoints: {
          768: {
            slidesPerGroup: 2,
          },
          960: {
            slidesPerGroup: 3,
          },
        },
        on: {
          setTranslate: _.debounce((translate) => {
            // hack to track scrolling interactions
            // whenever translate changed, it means slider moved
            // either by 1. clicking or 2. scrolling
            // if button is previously clicked, waiting for translate to change
            if (this.clickingToScroll === null) return // initial load, ignore
            if (this.clickingToScroll) {
              utils.mixpanelTracking(constants.eventCategories.TEMPLATE_LIBRARY, `Templates > Carousel > ${this.clickingToScroll}`, folderName)
              this.clickingToScroll = ''
            } else {
              const direction = translate > this.translate ? 'Left' : 'Right'
              this.translate = translate
              utils.mixpanelTracking(constants.eventCategories.TEMPLATE_LIBRARY, `Templates > Carousel > Swipe ${direction}`, folderName)
            }
          }, 200),
        },
      }
    },
    handleInputChanged: _.debounce(async function handleInputChanged() {
      if (!this.templateCategories || !this.searchText) {
        this.filteredPresentations = []
        this.noResult = false
        this.page = 1
        this.isLoadingMore = false
        this.isLoadmore = false
        return
      }
      this.isLoadingMore = false
      this.isLoadmore = false
      this.page = 1
      this.handleSearchPresentation()
    }, 300),
    async handleSearchPresentation() {
      const payload = {
        q: this.searchText,
        page: this.page,
        pageSize: this.limit,
      }

      try {
        const resp = await SearchApi.searchPresentation(payload)
        if (!this.searchText) return
        if (this.isLoadingMore) {
          this.filteredPresentations = this.filteredPresentations.concat(resp.body.presentations)
        } else {
          this.filteredPresentations = resp.body.presentations
        }
        if (resp.body.presentations.length < this.limit) {
          this.isLoadmore = false
        } else {
          this.page++
          this.isLoadmore = true
        }
        utils.mixpanelTracking(constants.eventCategories.TEMPLATE_LIBRARY, 'Search Template', null, null, {
          query: this.searchText,
          showingCount: this.filteredPresentations.length,
        })
      } catch (e) {
        Sentry.captureException(e)
      }
      this.isLoadingMore = false
      this.noResult = this.filteredPresentations.length === 0
    },
    triggerQueryByCategory() {
      if (this.$route.query.category && this.$route.query.category.length > 1) {
        this.getCategoryDetail(this.$route.query.category)
      }
    },
    triggerQuerySearch() {
      if (this.$route.query.q && this.$route.query.q.length > 1) {
        this.searchText = this.$route.query.q
        if (!this.searchText) {
          this.filteredPresentations = []
          this.noResult = false
          this.page = 1
          this.isLoadingMore = false
          this.isLoadmore = false
          return
        }
        this.isLoadingMore = false
        this.isLoadmore = false
        this.page = 1
        this.handleSearchPresentation()
      }
    },
    clearSearch() {
      this.searchText = ''
      this.handleInputChanged()
    },
    triggerPreviewPopUp() {
      if (this.$route.query.preview && this.$route.query.preview.length > 1) {
        this.previewPopup = true
        this.previewShareCode = this.$route.query.preview
      }
    },
    hidePreviewPopUp() {
      this.previewPopup = false
    },
    updatePublishedTemplateInList(template) {
      this.updateNewlyAddedAfterPublishAction(template)
    },
    async getCategoryDetail(id) {
      const res = await CategoryApi.getCategoryDetail(id)
      this.categorySelected = res
      if (res.id) { // Call api has result, emit event to stop loading
        EventBus.$emit('template-library--category-loaded')
      }
      this.$nextTick(this.initLazyLoad)
    },
    async loadMore() {
      if (this.isLoadingMore) return
      this.isLoadingMore = true
      this.handleSearchPresentation()
      utils.mixpanelTracking('Templates', 'Click load more', '')
    },
  },
}
</script>
<style scoped lang='scss'>
$thumbnail-ratio: calc(16 / 9);
$card-width: 250px;
.result--section {
  @apply relative m-4 mt-6 mb-16 md:px-6 h-full;
  .onboarding__arrow {
    @apply top-4 lg:-left-4 -left-8;
  }
  .categories-list {
    @apply mb-0;
  }
  .title-template-type {
    @apply flex mb-4 text-lg;
    .icon-template-type {
      margin-right: 9px;
    }
  }
  .template-container_item {
    @apply mb-5;
    .template-category-item {
      @apply mb-5;
    }
  }

  .title-template-category-container {
    @apply flex items-baseline;
    .title-item-template-category {
      flex-grow: 1;
    }
    .title-template-see-all {
      @apply flex flex-none font-bold items-center text-sm text-primary-90;
      font-style: normal;
    }
  }
  .slider {
    &.__slider {
      @apply relative;
      min-height: 220px;
      .slider {
        box-shadow: 0px 0px 10px -3px #888888;
      }
    }

    &.__prev,
      &.__next {
        @apply absolute cursor-pointer bg-base-0 rounded-full w-10 h-10;
        @apply flex justify-center items-center hover:text-primary-100;
        top: 48%;
        z-index: 2;

        &.swiper-button-disabled {
          @apply hidden;
        }
        &.hidden {
          display: none;
        }
      }

    &.__prev {
      left: -20px;
      @media (max-width: 767px) {
        left: -12px;
      }
    }

    &.__next {
      right: -20px;
      @media (max-width: 767px) {
        right: -12px;
      }
    }
  }
  .swiper-slide {
    width: $card-width;
    @apply pb-1 mb-4;
    &.swiper-slide__template-library {
      width: 250px;
    }
  }
  .template-container_item_category {
    .title-template-category-container {
      display: flex;
      justify-content: space-between;
      .title-template-type {
        margin-top: 32px;
      }
    }
  }
  .templates-container {
    @apply px-8;
  }
}
.publish {
  @apply absolute flex-none;
  top: 5.5rem;
  right: 1rem;
}

@media (max-width: 960px) {
  .container-template-category {
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
    -ms-overflow-style: auto;
  }
}

</style>
